export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12109.304d9a84.jpg";